import type { FC } from 'react';

import { Modal } from '@skillarea/lib-frontend';

import styles from './RulesModal.module.scss';

interface IRulesModalProps {
  isOpen: boolean;
  rulesContent: string;
  rulesTitle: string;
  gotItLabel: string;
  onClose: () => void;
  onGotIt: () => void;
}

export const RulesModal: FC<IRulesModalProps> = ({
  gotItLabel,
  isOpen,
  onClose,
  onGotIt,
  rulesContent,
  rulesTitle,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      isAutoClosing={false}
      onBeforeClose={onClose}
      title={rulesTitle}
      classNameModal={styles.dialogContent}
    >
      <h2 className={styles.title}>{rulesTitle}</h2>
      <div className={styles.divider} />
      <p className={styles.description}>{rulesContent}</p>
      <div className={styles.buttons}>
        <button type="button" className={styles.gotItButton} onClick={onGotIt}>
          {gotItLabel}
        </button>
      </div>
    </Modal>
  );
};
